import React, { useEffect, useState } from "react";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import { successfulCall } from "../../../utils/images";
import { Network } from "../../../utils/network";
import { getUser } from "../redux/profile.action";
import { trackMoengageEvent } from "../../../utils/commonMethods";
import FastImage from "../../../common/FastImage";
import Width from "../../../assets/Width";
const {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  StyleSheet,
  Dimensions,
  ScrollView,
} = require("react-native");
const { useDispatch } = require("react-redux");

function VerifyEmail({ email, onClose }) {
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const dispatch = useDispatch();
  const [otp, onChangeOtp] = React.useState("");

  const submitOtp = async () => {
    const inputData = {
      email,
      otp: otp,
    };
    trackMoengageEvent("Verify OTP Email Click", {
      Email: email,
      OTP: otp,
    });
    const res = await Network.verifyEmailOtp(inputData);
    const { data } = res;
    if (!data?.verified) {
      setError(data?.msg);
    } else {
      setIsSuccess(true);
    }
  };

  const onDoneClick = (e) => {
    dispatch(getUser());

    onClose();
  };

  return (
    <View style={{width: Width.width-80, flex: 1 }}>
      <ScrollView keyboardShouldPersistTaps={"handled"}>
        {!isSuccess ? (
          <View style={{ padding: 25 }}>
            <Text
              style={{
                ...globalFontStyle.appFontHeadingRegular,
                color: Colors.grey,
              }}
            >
              Please check your email
            </Text>
            <Text
              style={{
                ...globalFontStyle.appFontSmallText10,
                color: Colors.grey,
              }}
            >
              We've sent a code to {email !== null ? email : ""}
            </Text>
            <View style={styles.inputDiv}>
              <TextInput
                style={styles.input}
                onChangeText={onChangeOtp}
                value={otp}
                placeholderTextColor="#949494"
                placeholder="Enter OTP"
              />
            </View>
            {error !== null && error !== "" && (
              <Text
                style={{
                  ...globalFontStyle.appFontSmallText,
                  color: "#e90000",
                }}
              >
                {error}
              </Text>
            )}
            <View
              style={{ flexDirection: "row", marginTop: 10, marginBottom: 20 }}
            >
              <Button
                variant="secondary"
                onPress={() => onClose()}
                style={[styles.btnExternalStyle, { marginRight: 10 }]}
              >
                Cancel
              </Button>
              <Button
                style={styles.btnExternalStyle}
                variant="primary"
                onPress={() => submitOtp()}
              >
                Verify
              </Button>
            </View>
          </View>
        ) : (
          <View style={{ padding: 25, alignItems: "center" }}>
            <FastImage
              style={styles.checkboxImg}
              source={successfulCall()}
            />
            <Text
              style={{
                ...globalFontStyle.appFontHeadingRegular,
                color: Colors.grey,
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              Verification Successful!
            </Text>
            <Button
              variant="primary"
              onPress={onDoneClick}
              style={{ width: 120 }}
            >
              Done
            </Button>
          </View>
        )}
      </ScrollView>
    </View>
  );
}

export default VerifyEmail;

const styles = StyleSheet.create({
  btnExternalStyle: {
    borderRadius: 100,
  },

  input: {
    height: 40,
    borderWidth: 0,
    padding: 5,
    flex: 1,
    color: Colors.black,
  },
  inputDiv: {
    paddingTop: 15,
    flexDirection: "row",
    marginBottom: 16,
    paddingLeft: 0,
    alignItems: "center",
    borderBottomColor: "rgba(0, 0, 0, 0.2)",
    borderBottomWidth: 0.2,
  },
  checkboxImg: {
    width: 77,
    height: 77,
  },
});
